export enum RateGroupSettlementTrigger {
    Confirmation = 'Confirmation',
    End = 'End',
    EndDate = 'EndDate',
    Start = 'Start',
    StartDate = 'StartDate',
}
